import { render, staticRenderFns } from "./BaseInputGroupPassword.vue?vue&type=template&id=6bc9d28d"
import script from "./BaseInputGroupPassword.vue?vue&type=script&lang=js"
export * from "./BaseInputGroupPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports